module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-template __donate"
  }, [_c('h1', {
    staticClass: "page-title text-center",
    attrs: {
      "data-v-1f20e9ef": ""
    }
  }, [_vm._v("บริจาค")]), _vm._v(" "), _c('h3', {
    staticClass: "page-title text-center",
    attrs: {
      "data-v-fe7e2e22": ""
    }
  }, [_vm._v("เพื่อให้โอกาสทางการศึกษา")]), _vm._v(" "), _c('div', {
    staticClass: "container pd-sm-0 mt-3"
  }, [_c('div', {
    staticClass: "col-md-push-2 col-md-10 col-lg-push-2 col-md-8"
  }, [_c('div', {
    staticClass: "product product--inline"
  }, [_c('div', {
    staticClass: "product__block--form"
  }, [_c('div', {
    staticClass: "radius block shadow"
  }, [_c('product-donate-choice', {
    ref: "donateChoice",
    attrs: {
      "show-donate-type": true,
      "product": _vm.product,
      "classes": "col-1-5"
    },
    model: {
      value: (_vm.product.price),
      callback: function($$v) {
        _vm.$set(_vm.product, "price", $$v)
      },
      expression: "product.price"
    }
  }), _vm._v(" "), _c('donor-info', {
    model: {
      value: (_vm.attributes.info),
      callback: function($$v) {
        _vm.$set(_vm.attributes, "info", $$v)
      },
      expression: "attributes.info"
    }
  }), _vm._v(" "), _c('page-selector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.attributes.page),
      callback: function($$v) {
        _vm.$set(_vm.attributes, "page", $$v)
      },
      expression: "attributes.page"
    }
  }), _vm._v(" "), _c('product-cart-action', {
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "product": _vm.product,
      "attributes": _vm.attributes,
      "initialQuantity": 1,
      "addToCartButton": false,
      "buyNowButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn--purple btn--default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.donate($event)
      }
    }
  }, [_vm._v("บริจาค")])])], 1)])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-85ff7eea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85ff7eea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/products/donate.vue
// module id = 755
// module chunks = 1